<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from "axios";
import DataTable from "datatables.net-vue3";
import moment from "moment";
import { usePermissions } from '@/composables/usePermissions';

export default {
  page: {
    title: "Instant Pay Automation",
    meta: [{ name: "description", content: appConfig.description }],
  },

  data() {
    return {
      dtKey: 0,
      key: "",
      title: "Instant Pay Link Auto Generation",
      items: [
        {
          text: "Finance",
          href: "/",
        },
        {
          text: "Instant Pay Link Auto Generation",
          href: "/",
        },
      ],

      refundList: [],
      loadingDetail: true,
      loadingUpload: false,
      loadingEmail: false,
      ButtonSeen: true,
      id: "",
    };
  },
  setup() {
        const permissions = usePermissions();
        
        return {
            permissions,
        };
    },
  methods: {
    format_date(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD HH:mm:ss");
      }
    },

    getRefundList() {
      axios.defaults.headers.common["authorization"] = "Bearer " + localStorage.getItem("jwt");
      axios
        .get(process.env.VUE_APP_API_BASEURL + "instantpayAutomation/list")
        .then((response) => {
          if (response) {
            this.loadingDetail = false;
            this.refundList = response.data;
            this.dtKey += 1;
          } else {
            this.messageBag = ["No record."];
          }
        })
        .catch((error) => {
          this.messageBag = [error.error];
        });
    },

    downloadFile: function (id) {
      const posting_ = {
        instantpay_historyId: id,
      };

      axios
        .post(process.env.VUE_APP_API_BASEURL + "instantpayAutomation/export", posting_, { responseType: "blob" })
        .then((response) => {
          if (response) {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", "Instantpay Link.xlsx");
            document.body.appendChild(fileLink);

            fileLink.click();
          } else {
            this.messageBag = ["No record."];
          }
        })
        .catch((error) => {
          this.messageBag = [error.error];
        });
    },

    sendMail: function (id) {
      const result = confirm("Are you sure you want to send email?");
      if (result) {
        this.loadingEmail = true;
        axios
          .post(process.env.VUE_APP_API_BASEURL + "instantpayAutomation/" + id + "/send-email")
          .then((response) => {
            if (response) {
              alert("Email sent successfully");
              this.getRefundList();
            } else {
              this.messageBag = ["No record."];
            }
          })
          .catch((error) => {
            this.messageBag = [error.error];
          })
          .finally(() => {
            this.loadingEmail = false;
          });
      }
    },

    submitFile() {
      this.loadingUpload = true;
      let formData = new FormData();
      formData.append("sourceFile", this.sourceFile);
      axios.defaults.headers.common["authorization"] = "Bearer " + localStorage.getItem("jwt");
      axios
        .post(process.env.VUE_APP_API_BASEURL + "instantpayAutomation/data_processing", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response) {
            this.getRefundList();
            this.loadingUpload = false;
          } else {
            this.messageBag = ["No record."];
          }
        })
        .catch((error) => {
          this.messageBag = [error.error];
        });
    },

    handleFileUpload() {
      this.sourceFile = this.$refs.sourceFile.files[0];
    },
  },

  components: {
    Layout,
    PageHeader,
    DataTable,
  },

  mounted() {
    this.getRefundList();
    //this.get_country();
  },
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card">
      <div class="card-body">
        <div class="live-preview">
          <div class="row align-items-center g-12">
            <div class="card-body border-bottom-dashed border-bottom">
              <div class="row g-3">
                <div v-if="permissions.canCreate?.value" class="col-xl-6">
                  <input class="form-control" type="file" ref="sourceFile" v-on:change="handleFileUpload()" />
                </div>
                <!--end col-->
                <div class="col-xl-6">
                  <div class="row g-6">
                    <div class="col-sm-4">
                      <button v-if="permissions.canCreate?.value" v-on:click="submitFile()" class="btn btn-success w-100">
                        <i class="ri-equalizer-fill me-2 align-bottom"></i>Generate
                      </button>
                    </div>

                    <div class="col-sm-8">
                      <div></div>
                    </div>
                    <!--end col-->
                  </div>
                </div>
              </div>
              <!--end row-->

              <br /><br />
            </div>
            <div class="col-lg-12">
              <div class="pt-4">
                <h4 class="card-title">File Upload History</h4>
              </div>
              <div v-if="loadingDetail">
                <div class="spinner-border text-success" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <div v-else>
                <div class="table-responsive">
                  <DataTable
                    :options="{ lengthChange: false }"
                    :key="dtKey"
                    class="table table-striped table-nowrap mb-0"
                    id="example"
                  >
                    <thead class="table-secondary">
                      <tr>
                        <th>No.</th>
                        <th>Filepath</th>
                        <th>Created Date</th>
                        <th>Created By</th>
                        <th>Action</th>

                        <!--th scope="col">Action</th-->
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="(item, index) in refundList" :key="index" class="content">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.file_upload }}</td>
                        <td>{{ format_date(item.created_at) }}</td>
                        <td>{{ item.user_name }}</td>
                        <td>
                          <button v-if="permissions.canExport?.value" @click="downloadFile(item.id)" class="btn btn-secondary btn-sm">
                            <i class="ri-file-excel-2-line align-middle me-1"></i> Download File
                          </button>
                          <span>&nbsp;&nbsp;&nbsp;</span>
                          <button
                            v-if="permissions.canCreate?.value && item.mail_send_at == null"
                            @click="sendMail(item.id)"
                            class="btn btn-warning btn-sm"
                          >
                            Send Email
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </DataTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
